import { createFileRoute, redirect } from "@tanstack/react-router";

import { DataDeletionPage } from "@/features/datatools/DataDeletionPage";

export const Route = createFileRoute("/_app/data-deletion")({
  beforeLoad: ({ context }) => {
    if (context.info.edition !== "cloud" || !context.me?.permissions.includes("records.delete")) {
      throw redirect({ to: context.info.edition === "cloud" ? "/worklist" : "/admin" });
    }
  },
  component: DataDeletionPage,
});
